import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IMenu } from '../../interfaces/IMenu';
import { ICategory } from '../../interfaces/ICategory';
import { IOption } from '../../interfaces/IOption';

const apiUrl = Globals.apiPath + '/menus';

export default class MenusService {
  constructor() {}

  async getAll(restaurantId: number): Promise<IMenu[]> {
    let res = await axios.get<IMenu[]>(`${apiUrl}?r=${restaurantId}`);
    return res.data;
  }

  async getById(id: number): Promise<IMenu> {
    let res = await axios.get<IMenu>(`${apiUrl}/${id}`);
    return res.data;
  }

  async create(menu: IMenu, cloneFromId): Promise<IMenu> {
    let res = await axios.post<IMenu>(apiUrl, { ...menu, cloneFromId });
    return res.data;
  }

  async update(menu: IMenu): Promise<IMenu> {
    let res = await axios.put<IMenu>(`${apiUrl}/${menu.id}`, menu);
    return res.data;
  }

  async delete(menu: IMenu): Promise<IMenu> {
    let res = await axios.delete<IMenu>(`${apiUrl}/${menu.id}`);
    return res.data;
  }

  async activate(menu: IMenu): Promise<IMenu> {
    let res = await axios.post<IMenu>(`${apiUrl}/${menu.id}/activate`);
    return res.data;
  }

  async deactivate(menu: IMenu): Promise<IMenu> {
    let res = await axios.post<IMenu>(`${apiUrl}/${menu.id}/deactivate`);
    return res.data;
  }
}
